import { format } from 'date-fns';
import { cs } from 'date-fns/locale';
import React from 'react';
import {
    formateNumber,
    courseTermDescription,
    testTermDescription
} from '../../services/utils';

interface CourseCardPersonalTestPropsType {
    course: string;
    lessonCount: number;
    price?: number;
    from: string;
    timeFrom: string;
    city: string;
    street: string;
    streetNumber: string;
    placeName?: string;
    lector: string;
    lessonDate: string;
}

const CourseCardPersonalTest: React.FC<CourseCardPersonalTestPropsType> = (props) => {
    const { lessonCount, city, course, from, lector, price, street, streetNumber, placeName, timeFrom, lessonDate } = props;

    return (
        <>
            <h2 className="h-mb-05">{course}</h2>
            <ul className="is-small h-mb-0">
                {!!price && <li>{`Cena: ${formateNumber(price, 0)} Kč`}</li>}
                <li>
                    {testTermDescription({
                        dateFrom: from,
                        timeFrom: '',
                    })}
                </li>
                <li>
                    {timeFrom && /^\d{2}:\d{2}$/.test(timeFrom.trim())
                        ? `${format(new Date(`${from.split('T')[0]}T${timeFrom}`), 'EEEE · p', {
                            locale: cs,
                        })}`
                        : ''}
                </li>
                <li>{`${city} · ${street} ${streetNumber}${placeName ? ' · ' + placeName : ''}`}</li>
                {lector && <li>{`Lektor: ${lector}`}</li>}
            </ul>
        </>
    );
};

export default CourseCardPersonalTest;
